"use client";

import {
  type Configuration,
  PublicClientApplication,
} from "@azure/msal-browser";
import { MsalProvider as MsalProviderOrigin } from "@azure/msal-react";
import { Suspense, useEffect, useState } from "react";

interface Props {
  config: Configuration;
  children: React.ReactNode;
  loadingComponent?: React.ReactNode;
}

export function MsalProvider(props: Readonly<Props>) {
  const { loadingComponent = null } = props;

  const [msalInstance, setMsalInstance] =
    useState<PublicClientApplication | null>(null);

  useEffect(() => {
    const initMsal = async () => {
      const instance = new PublicClientApplication(props.config);
      await instance.initialize();
      setMsalInstance(instance);
    };

    initMsal();
  }, [props.config]);

  if (!msalInstance) {
    return loadingComponent;
  }

  return <MsalProviderOrigin instance={msalInstance}>
    <Suspense fallback={loadingComponent}>{props.children}</Suspense>
  </MsalProviderOrigin>;
}